// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"228e13c6","379":"4b09197e","634":"a30fd2dc"}[chunkId] + ".css";
};